export const NUMBER_OF_SKELETONS = 6;
